import { render, staticRenderFns } from "./FamilySite.vue?vue&type=template&id=5fc408ac&scoped=true"
import script from "./FamilySite.vue?vue&type=script&lang=js"
export * from "./FamilySite.vue?vue&type=script&lang=js"
import style0 from "./FamilySite.vue?vue&type=style&index=0&id=5fc408ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc408ac",
  null
  
)

export default component.exports